/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import { FaPython, FaLinux, FaAws, FaDocker, FaJenkins, FaGitlab } from 'react-icons/fa';
import { SiTerraform, SiKubernetes, SiGrafana, SiWireshark, SiArgo, SiMetasploit } from 'react-icons/si';
import { BsShieldLockFill } from 'react-icons/bs';
import { MdSecurity } from 'react-icons/md';
import { ReactComponent as JfrogIcon } from './assets/images/jfrog.svg';
import { ReactComponent as BashIcon } from './assets/images/gnubash.svg';
import { ReactComponent as PowerShellIcon } from './assets/images/Powershell.svg';
import { ReactComponent as NmapIcon } from './assets/images/nmap.svg';
import { ReactComponent as BurpSuiteIcon } from './assets/images/burpsuite.svg';
import splashAnimation from "./assets/lottie/splashAnimation";

const splashScreen = {
  enabled: true,
  animation: splashAnimation,
  duration: 2000
};

const illustration = {
  animated: true
};

const greeting = {
  username: "Rosie HN",
  title: "Hi all, Rosie HN here...",
  subTitle: emoji(
    "A curious mind and determined career changer with a strong interest in tech. A self-learner driven by patience, precision, and a passion for continuous growth. Detail-oriented and always seeking to improve and expand my skill set."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1ofFdKF_mqscH8WvXkSObnVvC9kK7Ldlu/view?usp=sharing",
  displayGreeting: true
};

const socialMediaLinks = {
  github: "https://github.com/RosieHN",
  linkedin: "https://www.linkedin.com/in/rosiehn/",
  gmail: "rosiehn96@gmail.com",
  facebook: "https://www.facebook.com/hong.00003",
  medium: "https://medium.com/@rosiehn96",
  display: true
};

const skillsSection = {
  title: "What I do",
  subTitle: "CURIOUS MIND IN CYBERSECURITY, ALWAYS DIGGING DEEP TO EXPLORE, SECURE & INNOVATE",
  skills: [
    emoji(
      "🛡️ Integrate security into CI/CD pipelines with GitLab CI/CD and Jenkins, including secret detection, dependency scanning, and automated testing."
    ),
    emoji(
      "🛡️ Manage secure artifact storage and promotion flows using JFrog Artifactory."
    ),
    emoji("🛡️ Secure and monitor containers using Docker and Kubernetes with proper image scanning, RBAC, and secrets management."),
    emoji(
      "🛡️ Set up Grafana dashboards to visualize system health, performance, and security metrics."
    ),
    emoji(
      "🛡️ Perform web and network security assessments using Burp Suite, Arachni, and Metasploit."
    ),
    emoji(
      "🛡️ Build automation scripts using Python to reduce manual tasks and enforce security controls."
    )
  ],
  softwareSkills: [
    {
      skillName: "Python",
      icon: FaPython
    },
    {
      skillName: "Linux",
      icon: FaLinux
    },
    {
      skillName: "Bash",
      icon: BashIcon
    },
    {
      skillName: "Powershell",
      icon: PowerShellIcon
    },
    {
      skillName: "AWS",
      icon: FaAws
    },
    {
      skillName: "Terraform",
      icon: SiTerraform
    },
    {
      skillName: "Docker",
      icon: FaDocker
    },
    {
      skillName: "Kubernetes",
      icon: SiKubernetes
    },
    {
      skillName: "ArgoCD",
      icon: SiArgo
    },
    {
      skillName: "Gitlab CI/CD",
      icon: FaGitlab
    },
    {
      skillName: "Jenkins",
      icon: FaJenkins
    },
    {
      skillName: "Jfrog",
      icon: JfrogIcon
    },
    {
      skillName: "Grafana",
      icon: SiGrafana
    },
    {
      skillName: "Wireshark",
      icon: SiWireshark
    },
    {
      skillName: "Nmap",
      icon: NmapIcon
    },
    {
      skillName: "Arachni",
      icon: BsShieldLockFill
    },
    {
      skillName: "Burp Suite",
      icon: BurpSuiteIcon
    },
    {
      skillName: "Metasploit",
      icon: SiMetasploit
    },
    {
      skillName: "NIST",
      icon: MdSecurity
    },
    {
      skillName: "SOC2",
      icon: MdSecurity
    },
    {
      skillName: "ISO/IEC 27001",
      icon: MdSecurity
    },
    {
      skillName: "CIS Benchmarks",
      icon: BsShieldLockFill
    }
  ],
  display: true
};

const openSource = {
  showGithubProfile: "true",
  display: true
};

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: true
};

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",
  achievementsCards: [
    {
      title: "GIAC Certified Incident Handler (GCIH)",
      subtitle:
        "The GIAC Incident Handler (GCIH) certification validates a practitioner's ability to detect, respond, and resolve computer security incidents using a wide range of essential security skills. GCIH certification holders have the knowledge needed to manage security incidents by understanding common attack techniques, vectors and tools, as well as defend against and respond to such attacks when they occur.",
      image: require("./assets/images/GCIH.png"),
      imageAlt: "GCIH",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credly.com/badges/0ef56873-7ce8-4fe1-8746-740a69142d53/public_url"
        }
      ]
    },
    {
      title: "WiCys Security Training Scholarship",
      subtitle:
        "Selected among 65 out of nearly 2,000 global candidates based on performance in a multi-round hacking. Gained in-depth knowledge in cybersecurity fundamentals, threat analysis, and incident response.",
      image: require("./assets/images/WiCysScholar.jpg"),
      imageAlt: "WiCysScholarship",
      footerLink: [
        {
          name: "Badge Scholarship",
          url: ""
        }
      ]
    },
    {
      title: "GIAC Security Essentials Certification (GSEC)",
      subtitle: "The GIAC Security Essentials (GSEC) certification validates a practitioner's knowledge of information security beyond simple terminology and concepts. GSEC certification holders are demonstrating that they are qualified for hands-on IT systems roles with respect to security tasks.",
      image: require("./assets/images/GSEC.png"),
      imageAlt: "GSEC",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credly.com/badges/1092eaac-2bdd-4e44-8d51-4d20a9af4a21/public_url"
        }
      ]
    },
    {
      title: "GIAC Foundational Cybersecurity Technologies (GFACT)",
      subtitle: "The GIAC Foundational Cybersecurity Technologies (GFACT) certification validates a practitioner's knowledge of essential foundational cybersecurity concepts. GFACT-certified professionals are familiar with practical skills in computers, technology, and security fundamentals that are needed to kickstart a career in cybersecurity.",
      image: require("./assets/images/GFACT.png"),
      imageAlt: "GFACT",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credly.com/badges/1092eaac-2bdd-4e44-8d51-4d20a9af4a21/public_url"
        }
      ]
    }
  ],
  display: true
};

const blogSection = {
  title: "Blogs",
  subtitle:
    "With a passion for securing systems and solving complex problems, I enjoy sharing my cybersecurity journey & sharing others what I've discovered along the way.",
  displayMediumBlogs: "false",
  blogs: [
    {
      url: "/blogsmd/WiCys-Scholarship/WiCys-Scholarship.md",
      route: "/blogs/WiCys-Scholarship",
      title: "Dummy to Dreamy: My Journey to a SANS Scholarship at WiCys",
      description:
        "My personal journey to earning a WiCys scholarship and discovering cybersecurity."
    },
    {
      url: "/blogsmd/Website/Website.md",
      route: "/blogs/Website",
      title: "Build and Launch Your Own Website for Just $1 – The Easy Way!",
      description: ""
    }
  ],
  display: true
};

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: true
};

const educationInfo = {
  display: true,
  schools: [
    {
      schoolName: "Camosun College",
      logo: require("./assets/images/camosun.png"),
      subHeader: "Diploma in Finance",
      duration: "2018 - 2020"
    }
  ]
};

const techStack = {
  viewSkillBars: true,
  experience: [
    {
      Stack: "Frontend/Design",
      progressPercentage: "90%"
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false
};

const workExperiences = {
  display: true,
  experience: [
    {
      role: "Software Engineer",
      company: "Facebook",
      companylogo: require("./assets/images/facebookLogo.png"),
      date: "June 2018 – Present",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      role: "Front-End Developer",
      company: "Quora",
      companylogo: require("./assets/images/quoraLogo.png"),
      date: "May 2017 – May 2018",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
    {
      role: "Software Engineer Intern",
      company: "Airbnb",
      companylogo: require("./assets/images/airbnbLogo.png"),
      date: "Jan 2015 – Sep 2015",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    }
  ]
};

const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",
  display: true
};

const contactInfo = {
  title: emoji("Contact Me "),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  email_address: "rosiehn96@gmail.com"
};

const isHireable = false;

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  podcastSection,
  contactInfo,
  isHireable,
  resumeSection
};